'use client';
export { KeyboardAvoidingView } from 'react-native';
